import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Card, CardBody, Col, Container, Row, Alert } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
//Import DPComponents
import DPTopToolBar from "../../../framework/widgets/DPTopToolBar"
import GroupMasterContent from "./GroupMasterContent"
import DPInfoBox from 'framework/layout/DPInfoBox'
import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPPermission from "framework/widgets/DPPermission"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPrintOption from "framework/widgets/DPPrintOptions"

import { Context } from '../../../app-contexts/CommonContexts';
import { useContext } from "react"
import { useHistory } from 'react-router-dom';
import { GroupSave } from "./GroupMasterController"

const GroupMaster = (props) => {
  const groupPara = props.location.search.replace('?', '',)

  let history = useHistory();
  const [typeGroup, SettypeGroup] = useState([])
  const [strTypeVal, SetTypeVal] = useState("")
  const [strGPTitle, SetGPTitle] = useState("")
  const [strCode, SetCode] = useState("")
  const [intCodeLen, SetCodeLen] = useState(0);
  const [codeEnable, setCodeEnable] = useState(false)
  const [DescEnable, setDescEnable] = useState(false)
  const [intDescLen, SetDescLen] = useState(0);
  const [strDesc, SetDesc] = useState("")
  const [arDetSet, SetDetSet] = useState([])
  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [saveEnable, setSaveEnable] = useState(true)
  const [maxFid, setFid] = useState(0)
  const [crEnable, setCrEnable] = useState(false)
  const [crBy, setCrBy] = useState("")
  const [mdBy, setMdBy] = useState("")
  const [crDate, setCrDate] = useState("")
  const [mdDate, setMdDate] = useState("")
  const [addNew, SetAddNew] = useState(true)
  const [deleteEnable, SetDeleteEnable] = useState(false)
  const [disabled, setDisabled] = useState(false)
  //*** End User activity related staes */

  //Alert Parameter
  const [show, setShow] = useState(false)
  const [AlertMsg, setAlertMsg] = useState('')
  const [AlertColor, setAlertColor] = useState('')
  const [ErrorMsg, setErrorMsg] = useState('')
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)

  //*****Menu Rights Start*/
  const [menuAccess, SetMenuAccess] = useState(false)
  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuProcess, SetMenuProcess] = useState(false)
  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")
  const [dpAlertShow, SetDpAlertShow] = useState(false)
  const [dpDescription, SetDpDescription] = useState("")
  const [LocationCode, setLocationCode] = useState("")
  const [LogUserType, setLogUserType] = useState("")
  const [LogCompanyCode, setLogCompanyCode] = useState("")
  const [menuCode, SetMenuCode] = useState("")
  //*****Menu Rights End */

  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(false)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [Reason, setReason] = useState("Created")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)
  const [printoptionShow, setprintoptionShow] = useState(false)
  //autocode generation related newly added code
  const [codeButton, setCodeButton] = useState(true)
  const [searchdisabled, setSearchdisabled] = useState(false)
  const [nullCode, setNullCode] = useState(false)
  const [autoCode, setAutoCode] = useState(false)

  /**********Loading Alert */
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
  const [helpUrl, setHelpUrl] = useState("")
  /**********End Loading Alert */

  //import from contexts
  const {
    isHeadOffice, getMenuDetails, masterAuditLog, addtoFavourite, getSelectedMasterPermissions, fetchAutoCode,
  } = useContext(Context);
  //import from contexts

  var time = process.env.REACT_APP_ALERTTIMEOUT

  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL

  useEffect(() => {
    loadUi(groupPara);

  }, [groupPara])

  // useEffect(() => {
  //   var menu = localStorage.getItem("MenuCode")
  //   SetMenuCode(menu)
  // }, [groupPara])

  //**Get File Details */
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]

    var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName

    SetParentName(parentname)
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    setLocationCode(LocationCode)
    setLogUserType(LogUserType)
    setLogCompanyCode(CompanyCode)

    var responseData = await getSelectedMasterPermissions(LogUserType, menu)

    if (!responseData.strMenuAccessRight) {
      history.push('/dashboard')
    }

    SetMenuAccess(responseData.strMenuAccessRight)
    SetMenuCreate(responseData.strMenuCreateRight)
    SetMenuDelete(responseData.strMenuDeleteRight)
    SetMenuModify(responseData.strMenuModifyRight)
    SetMenuPrint(responseData.strMenuPrintRight)
    SetMenuProcess(responseData.strMenuProcessRight)
    SetMenuName(responseData.strMenuName)
    SetMenuCode(responseData.strMenuTag)
    setPermissionReasonShow(responseData.strMenuReasonShow)
    setHelpUrl(responseData.strHelpUrl)

    var autoCodeRes = await fetchAutoCode(menu)

    if (autoCodeRes.nullCode == false) {
      setAutoCode(autoCodeRes.autoCode)
      setNullCode(false)
    } else {
      setNullCode(true)
      setAutoCode("")
    }

  }, [strCode, groupPara])

  // AuditLog
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname + window.location.search)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');

    await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
  }, [groupPara])


  const loadUi = async (fileNo) => {

    setSaveEnable(true)
    setDescEnable(false)
    setCodeEnable(false)
    SetCode("")
    SetDesc("")
    SetAddNew(true)
    SetDeleteEnable(false)
    setCrEnable(false)
    SetDetSet([])
    await fetch(`${ApiURL}groupsetup/search/${fileNo}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${authToken}`
      }
    }).then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          {
            let data = [...responseData.data]
            if (data.length > 0) {
              data.map(dr => {
                SetGPTitle(dr.gS_FILENAME)
                SetCodeLen(dr.gS_CODELEN)
                SetDescLen(dr.gS_DESCLEN)
                let det = []
                let count = 1;
                dr.groupSetDets.map(r => {
                  det.push({ dId: r.gS_FIELDID, dtype: r.gS_FIELDTYPE, dname: r.gS_FIELDNAME, feildLenth: r.gS_FIELDLEN, req: r.gS_FIELDREQ, value: "" })
                  count++
                })
                SetDetSet(det)
                setFid(count)
              })
              return
            }
          }
        }

      })
  }


  //********Delete button function */
  const handleDelete = () => {
    if (menuDelete == false) {
      SetDpDescription("You don't have permission to Delete !");
      SetDpAlertShow(true)
      return
    }


    const rowDelete = {
      "strMenuCode": menuCode,
      "strCode": strCode,
      "strLoggedCompany": LogCompanyCode,
      "strLoggedLocation": LocationCode,
      "strReason": Reason,
      "strCreateBy": crBy
    }

    //loading alert show
    SetLoadingAlert(true)
    SetLoadingAlerttitle("Deleting...")



    fetch(`${ApiURL}Common/Delete`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify(rowDelete)
      }
    ).then(Response => {
      if (Response.status == "200") {
        SetLoadingAlert(false)
        Response.json()
          .then(responseData => {

            if (responseData.data == "Cannot Delete, Record Already Used!") {
              displayAlertMessage('warning', responseData.data)
            } else {
              handleNew()
              displayAlertMessage('success', responseData.data)
            }
          }
          )
      } else if (Response.status == "400") {
        SetLoadingAlert(false)
        setDisabled(false)
        setCodeEnable(false)
        displayAlertMessage('danger', "Error !")
      } else {
        SetLoadingAlert(false)
        handleNew()
      }
    }).catch(error => {
      console.log(error.message)
    })
  }
  //*********Delete button function end */

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }

  //removebodyCss function
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const GetSelectRow = (e, row, isSelect, rowIndex) => {

    handleOnBlur(row.GP_CODE)
    setSaveEnable(false)
    tog_xlarge()

  }

  async function handleOnBlur(groupCode) {
    if (groupCode != "") {
      SetLoadingAlert(true)
      SetLoadingAlerttitle("Fetching...")
      await fetch(`${ApiURL}group/${groupPara}/${groupCode}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${authToken}`
        }
      }).then(Response => Response.json())
        .then(responseData => {
          SetLoadingAlert(false)
          if (responseData.success == true) {

            let data = responseData.data
            var count = Object.keys(data).length;
            if (count > 0) {
              let oldData = arDetSet;
              let det = []
              let count = 1;
              oldData.map(r => {
                det.push({ dId: r.dId, dtype: r.dtype, dname: r.dname, feildLenth: r.feildLenth, req: r.req, value: data[r.dname] })
                count++
              })
              SetDetSet(det)
              SetCode(data.GP_CODE)
              SetDesc(data.GP_DESC)
              setFid(count)
              setCrBy(data.CR_BY)
              setCrDate(data.CR_DATE)
              setMdDate(data.MD_DATE)
              setMdBy(data.MD_BY)
              setCrEnable(true)
              setCodeEnable(true)
              setDescEnable(true)
              setSaveEnable(false)
              SetAddNew(false)
              SetDeleteEnable(true)
              setReason("Updated")
              setSearchdisabled(true)
            } else {
              if (nullCode == false) {
                displayAlertMessage('success', "Record Not Found !")
                SetCode("")
                setCodeEnable(true)
              } else {
                displayAlertMessage('success', "Record Not Found !")
              }
            }

            return

          }
        }).catch(error => {
          console.log(error.message)
          SetLoadingAlert(false)
        })
    }
  }
  // async function loadSelectedData(strCode) {
  //   SetLoadingAlert(true)
  //   SetLoadingAlerttitle("Fetching...")
  //   if (strCode != "") {
  //     await fetch(`${ApiURL}group/${groupPara}/${strCode}`, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         'Authorization': `Bearer ${authToken}`
  //       }
  //     }).then(Response => Response.json())
  //       .then(responseData => {
  //         SetLoadingAlert(false)
  //         if (responseData.success == true) {
  //           alert("sss")
  //           let data = responseData.data
  //           var count = Object.keys(data).length;
  //           if (count > 0) {
  //             let oldData = arDetSet;
  //             let det = []
  //             let count = 1;
  //             oldData.map(r => {
  //               det.push({ dId: r.dId, dtype: r.dtype, dname: r.dname, feildLenth: r.feildLenth, req: r.req, value: data[r.dname] })
  //               count++
  //             })
  //             SetDetSet(det)
  //             SetCode(data.GP_CODE)
  //             SetDesc(data.GP_DESC)
  //             setFid(count)
  //             setCrBy(data.CR_BY)
  //             setCrDate(data.CR_DATE)
  //             setMdDate(data.MD_DATE)
  //             setMdBy(data.MD_BY)
  //             setCrEnable(true)
  //             setCodeEnable(true)
  //             setDescEnable(true)
  //             setSaveEnable(false)
  //             SetAddNew(false)
  //             SetDeleteEnable(true)
  //             setReason("Updated")
  //             setSearchdisabled(true)
  //           } else {
  //             if (nullCode == false) {
  //               displayAlertMessage('danger', "Record Not Found !")
  //               // setCodeEnable(true)
  //               // SetCode("")
  //             } else {
  //               displayAlertMessage('danger', 'Record Not Found !')
  //             }
  //           }
  //           return

  //         } else {
  //           if (nullCode == false) {
  //             setCodeEnable(true)
  //             displayAlertMessage('success', "Record Not Found !")
  //             SetCode("")
  //           } else {
  //             displayAlertMessage('success', 'Record Not Found !')
  //           }
  //         }
  //       })
  //   }
  // }

  function handleNew() {
    setTimeout(() => {
      loadUi(groupPara);
    }, 1)
    setCodeButton(true)
    setSearchdisabled(false)
    setReason("Created")
  }
  var validatePass = true


  const handlesave = async () => {
    //set autogenerate code to as CODE just for display purpuse
    if (addNew == true && nullCode == false) {
      SetCode(autoCode)
    }

    if (strCode == "" && nullCode == true) {
      displayAlertMessage('danger', "Please Enter  Code !")
      return;
    }
    if (strDesc == "") {
      displayAlertMessage('danger', "Please enter description")
      return;
    }
    var groupDet = await LoadGroupData();

    if (validatePass == false) {
      return
    }
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append('Authorization', `Bearer ${authToken}`);

    var raw = JSON.stringify({
      "intFileno": parseInt(groupPara),
      "strCode": addNew == true && nullCode == false ? autoCode : strCode,
      "strDesc": `${strDesc}`,
      "strMenuCode": menuCode,
      "strLoggedCompany": LogCompanyCode,
      "strLoggedLocation": LocationCode,
      "strReason": Reason,
      "blAddNew": addNew,
      "strCreatedBy": LogUserType,
      "groupDetailsN": groupDet
    });

    SetLoadingAlert(true)
    if (addNew == true) {
      SetLoadingAlerttitle("Saving...")
    } else {
      SetLoadingAlerttitle("Updating...")
    }


    const response = await GroupSave(raw)
    SetLoadingAlert(false)
    if (response.success) {
      displayAlertMessage('success', response.data)
      handleNew()
    } else {
      if (response.data == "Code Already Exsist!") {
        setCodeButton(false)
      }
      displayAlertMessage('danger', response.data)
    }

  }

  const handleEdit = () => {
    setSaveEnable(true)
    setDescEnable(false)
  }

  const LoadGroupData = async () => {
    var grp = [];
    arDetSet.map(r => {
      let txtvalue = document.getElementById(`GP_FIELD${r.dId}`)
      if (txtvalue != undefined) {
        let valText = "";
        if (parseInt(r.dtype) == 3) {
          valText = txtvalue.ariaChecked
        } else {
          valText = txtvalue.value
        }
        if (r.req == "1" || r.req == "true") {
          if (valText.length <= 0) {
            validatePass = false;
            displayAlertMessage('danger', "Please Enter " + r.dname)
            return;
          }
        }
        grp.push({
          "intFileNo": parseInt(groupPara),
          "strFieldName": `${r.dname}`,
          "strFieldValue": `${valText}`,
          "intFieldType": parseInt(r.dtype)
        });
      } else {
        grp.push({
          "intFileNo": parseInt(groupPara),
          "strFieldName": `${r.dname}`,
          "strFieldValue": ``,
          "intFieldType": parseInt(r.dtype)
        });
      }

    })
    return grp
  }

  //**Permission Check */
  const permission = (operation) => {
    const permissiondata = {
      strUsername: permissionName,
      strPassword: permissionPassword,
      strLocation: LocationCode,
      strMenuCode: menuCode
    }

    clearPermissionInputs()

    fetch(`${ApiURL}login/userpermission`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
        body: JSON.stringify(permissiondata)
      }
    ).then(Response => {
      if (Response.status == "200") {
        Response.json()
          .then(responseData => {

            let Access = (responseData.data.strMenuAccessRight)
            let Create = (responseData.data.strMenuCreateRight)
            let Delete = (responseData.data.strMenuDeleteRight)
            let Modify = (responseData.data.strMenuModifyRight)
            let Print = (responseData.data.strMenuPrintRight)
            let Process = (responseData.data.strMenuProcessRight)

            if (operation == "Save") {
              if (Create == true) {
                handlesave()
              } else if (Modify == true) {
                handlesave()
              } else {
                displayAlertMessage('danger', `This user don't have permisiion to ${addNew == true ? "save " : " update "} !`)
              }
            } else if (operation == "Delete") {
              if (Delete == true) {
                handleDelete()
              } else {
                displayAlertMessage('danger', "This user don't have permission to delete !")
              }
            } else if (operation == "Print") {
              if (Print == true) {
                setprintoptionShow(true)
              } else {
                displayAlertMessage('danger', "This user don't have permission to print !")
              }
            }
          }
          )

      } else if (Response.status == "400") {
        setDisabled(false)
        setCodeEnable(false)
        clearPermissionInputs()
        displayAlertMessage('danger', "Oops something went wrong !")
      } else if (Response.status == "403") {
        setDisabled(false)
        setCodeEnable(false)
        clearPermissionInputs()
        displayAlertMessage('danger', "You have not Permission to make changes !")
      } else if (Response.status == "404") {
        setDisabled(false)
        setCodeEnable(false)
        clearPermissionInputs()
        displayAlertMessage('danger', "Password or User Name is Invalid !")
      } else {
        ClearItem()
      }
    }).catch(error => {
      console.log(error.message)
    })
  }

  //CODE AUTO GEN
  const AutoGenerateCode = async () => {
    await fetch(`${ApiURL}common/autocode/${menuCode}`, {
      method: "GET",
      headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` },
    }).then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          if (responseData.data.length > 0) {
            SetCode(responseData.data)
            setAutoCode(responseData.data)
          } else {
            setCodeEnable(false)
          }
        }
      })
  }
  // print Function
  async function handlePrint(option) {
    var option = option
    SetLoadingAlert(true)
    SetLoadingAlerttitle("Generating Report...")

    const ReportURL = window.Links.ReportURL
    await fetch(`${ReportURL}api/group/report/${option == "PDF" ? 1 : 0}/${LogUserType}/${groupPara}`, {
      method: "GET",
      headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${authToken}` }
    }).then(Response => Response.json())
      .then(responseData => {

        if (responseData.success == true) {
          if (option == "PDF") {
            const msg = responseData.msg
            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.pdf`)
          }
          if (option == "XCEL") {
            const msg = responseData.msg
            window.open(`${ReportURL}temp_print/${msg.replace("\r\n", '')}.xls`)
          }

        }
        SetLoadingAlert(false)
      }).catch(error => {
        console.log(error.message)
        SetLoadingAlert(false)
      })
  }


  //Function for displaying Alert Messages.

  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setShow(true)

    setTimeout(() => {
      setShow(false)
    }, time)
  }


  //handle permission alert
  function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }


  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }

  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{strGPTitle} Master</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs title={parentName} breadcrumbItem={`${strGPTitle} Master`} />
          <DPAlert
            confirm_both={sweetAlertShow}
            title={`${strGPTitle} Master !`}
            description={AlertDescription}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            onConfirm={() => {
              setsweetAlertShow(false)
              if (AlertConfirmOption == 1) {

                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Created", true, true)
                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                  handlesave()
                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Updated", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }

              } else if (AlertConfirmOption == 2) {
                handleEdit()
              } else if (AlertConfirmOption == 3) {
                history.push('/dashboard')
              } else if (AlertConfirmOption == 4) {
                handleNew()
              } else if (AlertConfirmOption == 5) {

                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                  handleDelete()
                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Deleted", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }

              } else if (AlertConfirmOption == 6) {
                if (menuPrint == true && permissionReasonShow == false) {
                  setprintoptionShow(true)
                } else if (menuPrint == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Printed", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }
              }

            }}
            onCancel={() => {
              setsweetAlertShow(false)
            }}
          />
          <DPPermission
            confirm_both={permissionAlertShow}
            title={menuName}
            description={permissionAlertTitle}
            showReason={permissionReasonShow}
            nameDisable={permissionNameDisable}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            AlName={permissionName}
            AlNameOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionName(val2)
            }}
            AlPassward={permissionPassword}
            AlPasswardOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionPassword(val2)
            }}
            AlReason={Reason}
            AlReasonOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setReason(val2)
            }}
            onConfirm={() => {
              setPermissionAlertShow(false)
              if (AlertConfirmOption == 1) {
                permission("Save")
              } else if (AlertConfirmOption == 5) {
                permission("Delete")
              } else if (AlertConfirmOption == 6) {
                permission("Print")
              }
            }}
            onCancel={() => {
              setPermissionAlertShow(false)
              clearPermissionInputs()
            }}
          />
          <DPPrintOption
            confirm_both={printoptionShow}
            title={menuName}
            showCancel={true}
            cancelColor={"danger"}
            onConfirmpdf={() => {
              handlePrint("PDF")
              setprintoptionShow(false)
            }}
            onConfirmxcel={() => {
              handlePrint("XCEL")
              setprintoptionShow(false)
            }}
            onCancel={() => {
              setprintoptionShow(false)
            }}
          />
          <DPLoadingAlert
            confirm_both={loadingAlert}
            title={loadingAlertTitle}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPTopToolBar
                    //Help Button
                    helpEnable={helpUrl != "" ? true : false}
                    helpClick={() => {
                      window.open(helpUrl)
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={handleFavourite}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      setAlertDescription("Do you wish to refresh the screen ?");
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                    }}
                    //Save Button
                    saveEnable={saveEnable && isHeadOffice}
                    saveClick={() => {
                      setAlertDescription("Do you wish to save ?");
                      setAlertConfirmOption(1)
                      setsweetAlertShow(true)
                    }}
                    //ProcessButton
                    processEnable={false}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    editEnable={!saveEnable && isHeadOffice}
                    editClick={() => {
                      setAlertDescription("Do you wish to edit ?");
                      setAlertConfirmOption(2)
                      setsweetAlertShow(true)
                    }}
                    //Print Button
                    printEnable={true}
                    printClick={() => {
                      setReason("Printed")
                      setAlertDescription("Do you wish to print ?");
                      setAlertConfirmOption(6)
                      setsweetAlertShow(true)
                    }}
                    //Delete Button
                    deleteEnable={deleteEnable}
                    deleteClick={() => {
                      setReason("Deleted")
                      setAlertDescription("Do you wish to delete ?");
                      setAlertConfirmOption(5)
                      setsweetAlertShow(true)
                    }}
                    //Exit Button
                    exitEnable={true}
                    exitClick={() => {
                      setAlertDescription("Do you wish to exit ?");
                      setAlertConfirmOption(3)
                      setsweetAlertShow(true)
                    }}
                  />

                  <Row>
                    {show ? (
                      <Alert color={AlertColor} role="alert">
                        {AlertMsg}
                        <br />
                        <small>{ErrorMsg}</small>
                      </Alert>
                    ) : null}
                    <GroupMasterContent
                      typeGroup={typeGroup}
                      strTypeVal={strTypeVal}
                      SetTypeVal={e => {
                        loadUi(e["value"])
                        SetTypeVal(e["value"])
                      }}
                      Details={arDetSet}
                      strGPTitle={strGPTitle}
                      modelOpen={modal_xlarge}
                      modelTrigger={tog_xlarge}
                      GetSelectRow={GetSelectRow}
                      GroupNo={groupPara}
                      CodeValue={strCode}
                      CodeLen={intCodeLen}
                      CodeDisable={codeEnable}
                      CodeOnChange={e => {
                        let val1 = Text(
                          e.target,
                          intCodeLen,
                          true,
                          false,
                          "upper",
                          false
                        )
                        SetCode(val1)
                      }}
                      CodeOnBlur={e => handleOnBlur(e.target.value)}
                      DescValue={strDesc}
                      DescDisable={DescEnable}
                      DescOnChange={e => {
                        let val2 = Text(
                          e.target,
                          50,
                          true,
                          true,
                          "any",
                          true
                        )
                        SetDesc(val2)
                      }}
                      onButtonClick={e => {
                        AutoGenerateCode()
                        setCodeButton(true)
                      }}
                      btnDisable={codeButton}
                      SearchDisable={searchdisabled}
                      menuCode={menuCode}
                      autoCode={autoCode}
                    />
                  </Row>
                  <Row>
                    {crEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={crDate != '1900-01-01 00:00:00' ? (crDate) ? crDate.replace('T', ' ') : "" : ''}
                        modifiedBy={mdBy}
                        modifiedOn={mdDate != '1900-01-01 00:00:00' ? (mdDate) ? mdDate.replace('T', ' ') : "" : ''}
                      />
                    ) : null}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default GroupMaster





//socket programming to get message from server


